<template>
  <v-autocomplete
    v-model="selectedGrua"
    :items="gruaState.list"
    :loading="gruaState.loading"
    :search-input.sync="gruaState.search"
    :disabled="disabled"
    item-text="company"
    item-value="id"
    return-object
    dense
    outlined
    clearable
    hide-details
    hide-no-data
    prepend-inner-icon="mdi-truck"
    placeholder="Buscar empresa de grúa..."
    :filter="filterGruas"
    @input="onInput"
  >
    <template v-slot:item="{ item }">
      <v-list-item-content>
        <v-list-item-title>{{ item.company }}</v-list-item-title>
        <v-list-item-subtitle v-if="item.phone">Tel: {{ item.phone }}</v-list-item-subtitle>
      </v-list-item-content>
    </template>
    <template v-slot:selection="{ item }">
      <span class="caption text-truncate" style="max-width: 160px;">
        {{ item.company }}
      </span>
    </template>
  </v-autocomplete>
</template>

<script>
import _ from 'lodash'
import GruaService from '../services/GruaService'

export default {
  name: 'GruaSelectorInline',

  props: {
    value: { type: Object, default: null },
    currentDealerId: { type: [String, Number], default: null },
    disabled: { type: Boolean, default: false }
  },

  data () {
    return {
      selectedGrua: this.value || null,
      gruaState: {
        list: [],
        loading: false,
        search: ''
      }
    }
  },

  watch: {
    value (val) {
      this.selectedGrua = val
    },
    'gruaState.search' (val) {
      if (val && val.length >= 2) this.debouncedSearch()
      else if (!val) this.loadInitial()
    }
  },

  created () {
    this.loadInitial()
  },

  methods: {
    async loadInitial () {
      try {
        const params = { expand: 'dealership' }
        if (this.currentDealerId) params['filter[dealer_id]'] = this.currentDealerId
        const { data } = await GruaService.get(params)
        this.gruaState.list = data.data || []
      } catch (e) { /* silencioso */ }
    },

    filterGruas (item, queryText) {
      const text = `${item.company} ${item.cif || ''} ${item.phone || ''}`.toLowerCase()
      return text.includes(queryText.toLowerCase())
    },

    debouncedSearch: _.debounce(async function () {
      this.gruaState.loading = true
      try {
        const params = {
          'filter[company]': this.gruaState.search,
          expand: 'dealership'
        }
        if (this.currentDealerId) params['filter[dealer_id]'] = this.currentDealerId
        const { data } = await GruaService.get(params)
        this.gruaState.list = data.data || []
      } catch (e) {
        this.gruaState.list = []
      } finally {
        this.gruaState.loading = false
      }
    }, 300),

    onInput (val) {
      this.$emit('input', val)
    }
  }
}
</script>
